import { Grid, Typography, Container, Tabs, Box, Tab, } from "@mui/material";
import { useState } from "react";
import Signup from "./Signup";
import Login from "./Login";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Register = () => {
    const facebookClientId = process.env.REACT_APP_FACEBOOK_APP_ID;
    const [value, setValue] = useState(0);
    const navigate = useNavigate()

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticate)

    if (isAuthenticated) {
        navigate('/')
    }

    return (
        <Grid
            container
            sx={{
                minHeight: "100vh",
                width: '500px',
                margin: '20px auto',
            }}
            alignItems="center"
            justifyContent="center"
        >
            <Container>
                <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12} md={12}>
                        <Box
                            sx={{
                                padding: "17px 20px",
                                borderRadius: "20px",
                                border: "1px solid #e5e5e5",
                                backgroundColor: "#fff",
                                textAlign: "center",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <Typography sx={{ fontSize: "30px", fontWeight: "bold", }}>
                                Welcome to starBus
                            </Typography>
                            <Typography sx={{ fontSize: "16px", color: "#717182", mb: 2 }}>
                                Book your bus tickets with ease
                            </Typography>

                            <Box
                                sx={{
                                    bgcolor: "#f0f0f0",
                                    borderRadius: "30px",
                                    display: "block",
                                    padding: '6px 7px',
                                    height: "45px",
                                    marginBottom: '10px',
                                }}
                            >
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    sx={{
                                        "& .MuiTabs-flexContainer": { borderRadius: "30px" },
                                        "& .MuiTab-root": {
                                            textTransform: "none",
                                            borderRadius: "30px",
                                            minWidth: "50%",
                                            fontWeight: 600,
                                            color: "#364252",
                                            padding: "4px 8px",
                                            minHeight: "33px",
                                            fontFamily: "Segoe UI",
                                            fontSize: "14px",
                                            height: "33px",
                                            "&.Mui-selected": {
                                                bgcolor: "#fff",
                                                color: "#364252",
                                                fontFamily: "Segoe UI",
                                                fontSize: "14px",
                                            },
                                        },
                                        "& .MuiTabs-indicator": { display: "none" },
                                    }}
                                >
                                    <Tab label="Login" />
                                    <Tab label="Sign Up" />
                                </Tabs>
                            </Box>

                            {value === 0 && (
                                <Login facebookClientId={facebookClientId} />
                            )}
                            {value === 1 && (
                                <Signup facebookClientId={facebookClientId} />
                            )}
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </Grid>
    );
};

export default Register;
